import {useQuery} from "@apollo/client";
import {useState} from "react";

import {LoadingContainer} from "@/components/placeholder/LoadingContainer.tsx";
import {GQL_RUM_HEADER, RUMHeaderInput, RUMHeaderResponse} from "@/lib/queries/rum.ts";
import {RumCheckGraphs} from "@/pages/rum/v2/details/graphs/RumCheckGraphs.tsx";
// @ts-expect-error legacy
import RumCheckDetailHeader from "@/pages/rum/v2/details/RumCheckDetailHeader.jsx";

interface RUMCheckDetailsContentProps {
  id: number;
  payload: RUMHeaderInput;
  refreshSeconds?: number;
}

export const RUMCheckDetailsContent = ({id, refreshSeconds, payload}: RUMCheckDetailsContentProps) => {
  const [extraHeader, setExtraHeader] = useState<object | null>(null);
  const {data, loading, error, previousData} = useQuery<RUMHeaderResponse>(GQL_RUM_HEADER, {
    variables: {
      id,
      payload: payload,
    },
    pollInterval: refreshSeconds ? refreshSeconds * 1000 : undefined,
  });
  if (error) {
    console.error(error);
  }
  const response = loading ? previousData : data;
  if (loading || !response) {
    return <LoadingContainer />;
  }

  const {rumHeader} = response;
  return (
    <>
      <RumCheckDetailHeader data={{...rumHeader.data, ...extraHeader}} isAjax={false} />
      <RumCheckGraphs
        className="mt-3"
        onExtraHeader={setExtraHeader}
        checkName={rumHeader.name}
        headerData={rumHeader.data}
        payload={payload}
      />
    </>
  );
};
